<template>
  <v-container>
    <div v-if="form_visibility">
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-model="search_text"
          required
          label="Insurance Card Number"
          :rules="[v => !!v || 'Field cannot be empty']"
        ></v-text-field>
        <v-btn color="blue darken-1" text @click="clear">Clear</v-btn>
        <v-btn dark color="blue darken-1" @click="search"
          >Check Insurance</v-btn
        >
      </v-form>
    </div>
    <v-dialog v-model="dialog_progress" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="subtitle-1 text-center">
          fetching data, please wait...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <search-result v-if="result != null" v-bind:insurance_data="result" />
  </v-container>
</template>
<script>
import { EventBus } from "../main";
import { mapGetters } from "vuex";
import SearchResult from "@/components/SearchResult";
import { FETCH_INSURANCE } from "@/store/modules/actions.type";
export default {
  name: "search",
  components: {
    SearchResult
  },
  data: () => ({
    valid: true,
    dialog_progress: false,
    form_visibility: true,
    search_text: null,
    result: null
  }),
  created() {
    EventBus.$on("closeChildComponent", evnt => {
      if (!this.form_visibility) this.form_visibility = evnt;
      if (this.result && this.search_text) {
        this.result = null;
        this.search_text = null;
      }
    });
  },
  watch: {
    dialog_progress(val) {
      if (!val) return;
    }
  },
  methods: {
    fetchInsurance(ins_no) {
      this.$store
        .dispatch(FETCH_INSURANCE, "check-insurance/" + ins_no)
        .then(res => {
          this.result = res;
          this.form_visibility = false;
          this.dialog_progress = false;
          //console.log(this.staff)
        });
    },
    search() {
      if (!this.$refs.form.validate()) return;

      let ins_no = this.search_text;

      this.dialog_progress = true;

      if (ins_no) {
        let insurance_no = ins_no.split("/").join("-");
        this.fetchInsurance(insurance_no);
      }
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>
